import React from 'react';
import { useNavigate } from '@thd-olt-component-react/router';
import { observer } from 'mobx-react-lite';
import ConfirmDialog from '../../common/ConfirmDialog/ConfirmDialog';
import { useStore } from '../../../store/index';
import { JOB_POSTING_STATUS, EXP_ROUTES } from '../../../utils/constants';

const dialogText = {
  DRAFT: (
    <>
      Are you sure your want to delete your job posting draft?
      <br />
      All of your work up to this point will be deleted.
      <br />
      <strong>The action cannot be undone.</strong>
    </>
  ),
  DEFAULT: (
    <>
      Are you sure your want to delete this posting?
      <br />
      All of your job applicants, recommended candidates and the posting details for this job will
      be deleted.
      <br />
      <strong>The action cannot be undone.</strong>
    </>
  )
};

const DeleteJobPostingDialog = () => {
  const {
    jobPostingStore: { pendingDeletionJobPosting, toggleDeleteJobPostingModal, deleteJobPosting }
  } = useStore();

  const navigate = useNavigate();

  function deleteConfirm() {
    deleteJobPosting(pendingDeletionJobPosting?.jobPostingId);
    navigate(EXP_ROUTES.JOB_POSTINGS);
  }

  return (
    <ConfirmDialog
      headerText="Delete Job Posting"
      open={!!pendingDeletionJobPosting}
      onConfirm={() => {
        deleteConfirm();
      }}
      onClose={() => {
        toggleDeleteJobPostingModal();
      }}
      confirmText="Delete Posting"
      cancelText="Cancel"
    >
      {pendingDeletionJobPosting?.status === JOB_POSTING_STATUS.DRAFT
        ? dialogText.DRAFT
        : dialogText.DEFAULT}
    </ConfirmDialog>
  );
};

export default observer(DeleteJobPostingDialog);
